import { render } from "./AppDownload.vue?vue&type=template&id=501b4d2c&scoped=true"
import script from "./AppDownload.vue?vue&type=script&lang=js"
export * from "./AppDownload.vue?vue&type=script&lang=js"

import "./AppDownload.vue?vue&type=style&index=0&id=501b4d2c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501b4d2c"]])

export default __exports__